import { resolveThemeId } from '../types/theme';

export const TEST_TOKEN = 'test';
export const TEST_TOKEN_GUEST = 'guest_test';

export const QH = 'QuizHeroes';
export const TELEGRAM_LINK = 'https://t.me/PlagueGame';
export const TELEGRAM_SUPPORT_LINK = 'https://t.me/QuizHeroesSupport';
export const VK_LINK = 'https://vk.com/quizheroes';
export const INSTAGRAM_LINK = 'https://www.instagram.com/quizheroes';

export const DEFAULT_LOCALE = 'ru';

export const NAME_MAX_LENGTH = 100;

function envBool(value: string | undefined, defaultValue: boolean): boolean {
  if (value === undefined || value === '') {
    return defaultValue;
  }

  return value === 'true' || value === '1';
}

export const ENV = {
  API_URL: process.env.API_URL ?? '',
  THEME: resolveThemeId(process.env.THEME),
  FOOTER_SOCIALS: envBool(process.env.FOOTER_SOCIALS, false),
};

export const isDev = () => process.env.NODE_ENV === 'development';

export const isTestEnv = () => window.location.host.split('.')[0] === 'beta';
